import { render, staticRenderFns } from "./EnterName.vue?vue&type=template&id=2028b22f"
import script from "./EnterName.vue?vue&type=script&lang=js"
export * from "./EnterName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports